import { CheckCircle } from "@mui/icons-material";
import { Card, Typography } from "@mui/material";
import React from "react";

export default function EsclationResponseMessage({
  message,
}: {
  message: string;
}) {
  return (
    <Card elevation={2} className="flex items-center p-4 gap-3">
      <CheckCircle className=" " color="success" />
      <Typography variant="body2" className="Typography-5 bg-white rounded-md">
        {message}
      </Typography>
    </Card>
  );
}
